import React from 'react'

import { PaddingProps } from 'styled-system'

import { SectionWrapper } from 'Components/Blocks'
import { LEGEND } from 'Components/Sections/StartupCraftProcess/constants'
import { Column, Row, Text } from 'Components/UI'

import GanttGlyph from 'Assets/Svg/gantt.svg'

import { Content, LegendHolder, LegendItemPoint, SvgHolder } from './styles'

type Props = PaddingProps

function StartupCraftProcessSection({ ...rest }: Props) {
  return (
    <SectionWrapper {...rest}>
      <Column alignCenter fullWidth gap={17}>
        <Text as="h2" center medium title title40>
          StartupCraft process
        </Text>

        <Content
          flexDirection={[
            'column-reverse',
            'column-reverse',
            'column-reverse',
            'column-reverse',
            'column-reverse',
            'row',
          ]}
          gap={[17, 17, 17, 17, 17, 11]}
        >
          <LegendHolder
            flexDirection={['row', 'row', 'row', 'row', 'row', 'column']}
            gap={[7, 7, 7, 7, 7, 3]}
          >
            {LEGEND.map(item => (
              <Row
                alignCenter
                gap={[4, 4, 4, 4, 4, 5]}
                height={[24, 24, 24, 24, 24, 48]}
                key={item.id}
              >
                <LegendItemPoint borderColor={item.color} />

                <Text body20 medium nowrap title>
                  {item.caption}
                </Text>
              </Row>
            ))}
          </LegendHolder>

          <SvgHolder>{GanttGlyph()}</SvgHolder>
        </Content>
      </Column>
    </SectionWrapper>
  )
}

export default StartupCraftProcessSection
